const toggleButton = {
  MuiToggleButtonGroup: {
    styleOverrides: {
      root: ({ theme }) => ({
        pointerEvents: 'auto',
        backgroundColor: theme.palette.background.paper,
        borderRadius: 50,
      }),
    },
  },
  MuiToggleButton: {
    styleOverrides: {
      root: ({ theme }) => {
        return {
          borderRadius: 50,
          color: theme.palette.text.icon,
        };
      },
    },
  },
};

export default toggleButton;
